
export const status = {
  'status.complete': 'Complete',
  'status.incomplete': 'Incomplete',
  'status.pending': 'Pending',
  'status.rejected': 'Rejected',
  'status.approved': 'Approved',
  'status.review': 'Under Review',
  'status.draft': 'Draft',
  'status.submitted': 'Submitted',
  'status.processing': 'Processing',
  'status.error': 'Error',
  'status.success': 'Success',
  'status.warning': 'Warning',
  'status.info': 'Information',
  'status.active': 'Active',
  'status.inactive': 'Inactive',
  'status.expired': 'Expired',
  'status.closed': 'Closed',
  'status.permanent': 'Permanent',
  'status.comingSoon': 'Coming Soon',
  'status.disabled': 'Disabled',
  'status.enabled': 'Enabled',
  'status.locked': 'Locked',
  'status.unlocked': 'Unlocked',
  'status.blocked': 'Blocked',
  'status.unblocked': 'Unblocked',
  'status.verified': 'Verified',
  'status.unverified': 'Unverified',
  'status.suspended': 'Suspended',
  'status.unsuspended': 'Unsuspended',
  'status.deleted': 'Deleted',
  'status.restored': 'Restored',
  'status.archived': 'Archived',
  'status.unarchived': 'Unarchived',
  'status.published': 'Published',
  'status.unpublished': 'Unpublished',
  'status.profileComplete': 'Profile Complete',
  'status.inReview': 'In Review',
  'status.needsUpdate': 'Needs Update',
  'status.subsidyInProgress': 'Subsidy In Progress',
  'status.inProgress': 'In Progress',
  'status.inPreparation': 'In Preparation',
  'status.readyToSubmit': 'Ready to Submit',
  'status.uploadpending': 'Upload Pending',
  'status.completed': 'Completed',
  'status.failed': 'Failed'
} as const;
